import { createApp } from 'vue'
import App from './App.vue'
import router from './routes'
import { createPinia } from 'pinia'
import ViewUIPlus from 'view-ui-plus'

import { locale } from 'view-ui-plus'
import lang from 'view-ui-plus/dist/locale/ja-JP'
import 'view-ui-plus/dist/styles/viewuiplus.css'

locale(lang)

// Import default app css
require('./assets/sass/app.scss')

createApp(App).use(router).use(createPinia()).use(ViewUIPlus).mount('#app')
